import React from "react";

import {
  Typography as MuiTypography,
  TypographyProps,
  styled,
} from "@mui/material";
import { SpacingProps, spacing } from "@mui/system";

const TypographyRaw = styled(styled(MuiTypography)(spacing))<{
  component?: React.ElementType;
}>``;

type Props = TypographyProps &
  SpacingProps & {
    component?: React.ElementType;
  };

export const Typography: React.FC<Props> = (props) => (
  <TypographyRaw {...props} />
);
